import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for C5M5 (Sales Return Writeoff)
// ============================================================

export interface WriteoffItem {
  fc130_01: string;    // Sales return no (PK)
  fc130_10: string;    // Customer code
  fc130_11: string | null;  // Return date (ISO string)
  fc130_12_id: string; // Warehouse code
  fc130_12: string;    // Warehouse name
  fc130_13: number;    // Total return qty
  fc130_90: number;    // Version
}

export interface QueryResponse {
  items: WriteoffItem[];
  total: number;
}

export interface ValidateItemResponse {
  valid: boolean;
  message?: string;
}

export interface ExecuteResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const c5m5Api = {
  /** Query sales return items within a range */
  async query(startNo: string, endNo: string): Promise<QueryResponse> {
    const res = await apiClient.post('/api/c5m5/query', {
      start_no: startNo,
      end_no: endNo,
    });
    return res.data;
  },

  /** Validate a single item for writeoff eligibility */
  async validateItem(returnNo: string): Promise<ValidateItemResponse> {
    const res = await apiClient.post('/api/c5m5/validate-item', {
      return_no: returnNo,
    });
    return res.data;
  },

  /** Execute batch writeoff for selected items */
  async execute(returnNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/c5m5/execute', {
      return_nos: returnNos,
    });
    return res.data;
  },
};
